import { Plugin } from "prosemirror-state";
export function createMaxLengthPlugin(maxLength) {
    return new Plugin({
        appendTransaction: (transactions, oldState, newState) => {
            const currentLength = newState.doc.content.size;
            if (maxLength && currentLength > maxLength) {
                const oldLength = oldState.doc.content.size;
                const addedLength = currentLength - oldLength;
                const oversize = currentLength - maxLength;
                const currentPos = oldState.selection.from;
                return newState.tr.insertText("", currentPos + addedLength - oversize, currentPos + addedLength);
            }
        },
    });
}
